import { pushSearchesToApi } from '@growth/recent-search/helper';
import dateFormat from "dateformat";
const getEpochs = (calendarDate) => {
    try {
      const date = calendarDate?.date;
      const newDate = new Date(date.toDateString());
      const epochTime = newDate.getTime(); 
      return epochTime;
    } catch (e) {
      console.log(e);
    }
  };

const formatDateTime = (dateStr: string) => {
    let datePart = dateStr.slice(6, 8);
    let month = dateStr.slice(4, 6);
    const year = dateStr.slice(0, 4);
    return `${datePart}-${month}-${year} 00:00:00`;
};

const convertToDate = (dateStr: string) => {
  const datePart = dateStr.slice(6, 8);
  const month = dateStr.slice(4, 6);
  const year = dateStr.slice(0, 4);
  const newDate = new Date(`${month}/${datePart}/${year}`)
  return newDate;
}

export const sendRecentSearchData = (commonData, src_locus_id, dest_locus_id) => {
  const {src_name, dest_name, src_vid, dest_vid, doj, srcLat, srcLon, destLon, destLat, srcState, destState} = commonData
  const searchObj = {
    calendarDate: dateFormat(convertToDate(doj), 'yyyymmdd'),
    srcCity :  src_name,
    dest: {dest: dest_name },
    destCity :  dest_name,
    timestamp: dateFormat(convertToDate(doj), 'yyyymmdd'),
    srcId: src_vid,
    destId : dest_vid,
    departDate: dateFormat(convertToDate(doj), 'yyyymmdd'),
    gd: {
      t: "bus",
      d: dateFormat(convertToDate(doj), 'yyyymmdd'), // this has to be in yyyymmdd
      sn:  src_name,
      dn: dest_name,
      did: dest_vid,
      sid: src_vid,
      srcState: srcState,
      srcLat: srcLat,
      srcLon: srcLon,
      destLat: destLat,
      destLon: destLon,
      destState: destState,
  }
  };
    const searchDetails = {
      searchContext: {
        from: {
          lobCity: searchObj.srcId,
          name: searchObj.srcCity,
          countryCode: 'IN',
          lobCountry: 'India',
          locus:{
              country: "IN",
              city: src_locus_id,
              type: "CITY",
              name: searchObj.srcCity
          }
        },
        fromDateTime: {
          timestamp:  getEpochs(searchObj.calendarDate),
          timezone: 'GMT',
          str: formatDateTime(searchObj.departDate),
        },
  
        to: {
          lobCity: searchObj.destId,
          name: searchObj.destCity,
          countryCode: 'IN',
          lobCountry: 'India',
          locus:{
            country: "IN",
            city: dest_locus_id,
            type: "CITY",
            name: searchObj.destCity
        }
        },
        funnelSource : 'bus',
        journeyType : 'OW',
        meta: {
          tg: 302,
          gd: JSON.stringify(searchObj.gd),
          deeplink:
           `https://www.goibibo.com/bus/search/?src=${encodeURIComponent(searchObj.srcCity)}&dest=${encodeURIComponent(searchObj.destCity)}&src_id=${searchObj.srcId}&dest_id=${searchObj.destId}&onwDate=${searchObj.departDate}`
        },
        lob: "buses",
        lobCategory: "BUS",
      }
    }
  
    pushSearchesToApi({
      searchDetails:searchDetails,
      lobName: "bus",
      onPushSuccess: (res) => {
        console.log("onppushsuccess", res);
      },
      onPushFail: (err) => {
        console.log("onppushfail", err);
      },
    });
  };


export const getPokusKeys = (pokusKeys) => {
  let res = ''
  if (Object.keys(pokusKeys).length > 0) {
    for (let item in pokusKeys) {
      let firstCharValue = pokusKeys[item]?.toString()?.split('')[0]?.toUpperCase()
      res += `${item}_${firstCharValue}|`
    }

  }
  return res;
}
